var _path, _g, _path2, _g2, _path3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBacktoTOp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17001 18C1.17001 14.7456 2.13505 11.5642 3.94311 8.8582C5.75116 6.15221 8.32102 4.04313 11.3277 2.79766C14.3344 1.55219 17.6429 1.22627 20.8349 1.86111C24.0268 2.49594 26.9588 4.06303 29.2601 6.3642C31.5614 8.66538 33.1287 11.5973 33.7637 14.7892C34.3987 17.9811 34.073 21.2896 32.8277 24.2964C31.5824 27.3031 29.4735 29.8731 26.7676 31.6813C24.0618 33.4896 20.8805 34.4548 17.626 34.455C13.2632 34.4505 9.08028 32.7154 5.99518 29.6305C2.91009 26.5456 1.17477 22.3628 1.17001 18ZM17.626 0.625C14.1895 0.624802 10.8301 1.64366 7.9727 3.55273C5.11527 5.4618 2.88811 8.17533 1.57289 11.3502C0.257662 14.525 -0.0865636 18.0186 0.583742 21.3891C1.25405 24.7596 2.90878 27.8556 5.33867 30.2856C7.76857 32.7157 10.8645 34.3706 14.2349 35.0411C17.6054 35.7116 21.099 35.3675 24.2739 34.0525C27.4488 32.7375 30.1625 30.5105 32.0717 27.6531C33.981 24.7958 35 21.4365 35 18C34.9934 13.3941 33.1608 8.97866 29.904 5.72168C26.6472 2.46469 22.2319 0.631878 17.626 0.625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0.625H0.25V35.375H35V0.625Z",
    fill: "url(#paint0_linear_1_628)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 10,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.184 12.7131C17.1146 12.7826 17.0757 12.8768 17.0757 12.9751C17.0757 13.0733 17.1146 13.1675 17.184 13.2371L26.361 22.4151C26.3955 22.4495 26.4364 22.4769 26.4814 22.4955C26.5265 22.5142 26.5748 22.5238 26.6235 22.5238C26.6723 22.5238 26.7205 22.5142 26.7656 22.4955C26.8106 22.4769 26.8515 22.4495 26.886 22.4151C26.9205 22.3806 26.9478 22.3397 26.9665 22.2946C26.9851 22.2496 26.9947 22.2013 26.9947 22.1526C26.9947 22.1038 26.9851 22.0555 26.9665 22.0105C26.9478 21.9655 26.9205 21.9245 26.886 21.8901L17.709 12.7131C17.6395 12.6437 17.5452 12.6047 17.447 12.6047C17.3488 12.6047 17.2536 12.6437 17.184 12.7131Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.03 12.604H17.039V22.559H27.03V12.604Z",
    fill: "url(#paint1_linear_1_628)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.061 12.541L7.884 21.718C7.81743 21.7882 7.78093 21.8817 7.78226 21.9784C7.7836 22.0751 7.82267 22.1675 7.89114 22.2359C7.95961 22.3042 8.05208 22.3431 8.14882 22.3443C8.24556 22.3454 8.33892 22.3087 8.409 22.242L17.586 13.065C17.6219 13.031 17.6507 12.99 17.6706 12.9447C17.6904 12.8993 17.701 12.8504 17.7017 12.8009C17.7024 12.7514 17.6932 12.7023 17.6745 12.6564C17.6559 12.6105 17.6283 12.5688 17.5933 12.5337C17.5583 12.4987 17.5167 12.471 17.4708 12.4523C17.425 12.4336 17.3758 12.4242 17.3263 12.4248C17.2768 12.4254 17.2279 12.4359 17.1825 12.4557C17.1371 12.4755 17.0961 12.5042 17.062 12.54",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.73 12.4321H7.73901V22.3871H17.73V12.4321Z",
    fill: "url(#paint2_linear_1_628)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_628",
    x1: 0.25,
    y1: 35.375,
    x2: 0.70175,
    y2: 35.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#017AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#2E6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#555DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#7552FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#8E49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#A043FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#AA40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_628",
    x1: 0.25412,
    y1: 35.3711,
    x2: 0.713706,
    y2: 35.3711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#017AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#2E6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#555DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#7552FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#8E49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#A043FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#AA40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_628",
    x1: 0.245764,
    y1: 35.3784,
    x2: 0.715341,
    y2: 35.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#017AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#2E6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#555DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#7552FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#8E49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#A043FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#AA40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktoTOp);
export default __webpack_public_path__ + "static/media/BacktoTOp.157f68886abbe4078b95c4a6a923f8a3.svg";
export { ForwardRef as ReactComponent };